import cpSessionConf from "./cp_sessions";
import SelectContact from "@/views/crud/modules/SelectContact.vue";

export default {
  key: "account",
  id: "acc_id",
  fields: [
    { key: "acc_id" },
    { key: "car_reg_no" },
    { key:"rfid_cards" },
    // { key: "first_name" },
    // { key: "last_name" },
    // { key: "mobile_no" },
    // { key: "email" },
    // { key: "acc_bal" },
    // { key: "hkid" },
    // { key: "birthday", type: "date" },
    { key: "acc_status", field: "acc_status.name_chi", value: "acc_status.acc_status_code", type: "select" },
    // // { key: "account_cp_setup", type: "component", component: AccountCpSetup, hidden: ["list","create"] },
    { key: "master_flag", type: "boolean", privilege: ["READ_MASTER_FLAG"]},
    { key: "max_charge_time" },

    { type: "action-btn" },
    { key: "locIds", type:"componentColumn", label:"address", value:"loc_id", get_option:"cp_locs", get_data:"account_and_cp_loc", component:SelectContact, hidden: ["list"]},


    // { key: "tnc_flag", type: "boolean", hidden: ["list"] },
    // { key: "rfid_cards", hidden: ["list"] },
    // { key: "default_lang", hidden: ["list"] },
    // { key: "act_flag", type: "boolean", hidden: ["list"] },
  ],
  options: {
    acc_status: {
      key: "account_statuses",
      label: "name_chi",
      value: "acc_status_code"
    },
  },
  action: ["view","create","edit"],
  structure: [
    ["car_reg_no"],
    ["rfid_cards"],
    // ["first_name","last_name"],
    // ["email","mobile_no"],
    // ["hkid","rfid_cards"],
    // ["birthday"],
    // ["default_lang"],
    ["acc_status"],
      ["locIds"],
      ["master_flag"],
      ["max_charge_time"]
    // ["tnc_flag","act_flag"],
  ],
  view: [
    
    ["acc_id",{ key: "acc_status", value: "acc_status.name_chi" }],
    ["car_reg_no"],
    ["rfid_cards"],
    [{key:"master_flag", privilege: ["READ_MASTER_FLAG"], type: "boolean"}],
    ["max_charge_time"]

    // ["mobile_no","acc_bal"],
    // ["first_name","last_name"],
    // ["hkid","birthday"],
    // ["email","default_lang"],
    // [{ key: "tnc_flag", type: "boolean" },"rfid_cards"],
    // ["address"],
    // ["remark"],
    // ["reg_dttm",{ key: "cre_user", value: "cre_user.name" }],
    // ["lupd_dttm",{ key: "lupd_user", value: "lupd_user.name" }],
    // [{
    //   type: "tabs",
    //   items: [
    //     {
    //       ...cpSessionConf,
    //       key: "cp_sessions",
    //       name: "cp_session",
    //       params: ["acc_id"],
    //       action: []
    //     }
    //   ]
    // }]
  ]
}